function getMaxPolicies(plan, period) {
  const duration = Array.isArray(plan.durations) ? plan.durations : plan.durations[period]
  const policies = Math.max(...Object.keys(duration).map(value => parseInt(value)))

  return {
    duration,
    policies
  }
}

export default getMaxPolicies
